"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _recognition = _interopRequireDefault(require("../../services/recognition"));
var _cmx = _interopRequireDefault(require("../../services/cmx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class RewardChoiceLabel extends _react.default.Component {
  state = {
    loading: false,
    rewardChoices: []
  };
  componentDidMount() {
    this.loadRewardChoices();
  }
  render() {
    const {
      rewardChoiceId,
      ...props
    } = this.props;
    const {
      loading,
      rewardChoices
    } = this.state;
    props.auth = undefined;
    const rewardChoice = rewardChoices.find(rc => rc.id === rewardChoiceId);
    return /*#__PURE__*/_react.default.createElement("span", props, rewardChoiceId && rewardChoice ? /*#__PURE__*/_react.default.createElement("span", null, rewardChoice.name) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
      size: "small"
    }) : /*#__PURE__*/_react.default.createElement("span", null));
  }
  loadRewardChoices = async () => {
    const {
      auth
    } = this.props;
    this.setState({
      loading: true
    });
    try {
      const recognitionService = new _recognition.default(auth.state);
      const rewardChoices = await recognitionService.searchRewardChoices();
      const cmxService = new _cmx.default(auth.state);
      const strings = await cmxService.getStringsWithAttributes('recognition', 'en-US', [{
        name: 'rewardChoice.name',
        attributes: {
          rewardChoiceId: rewardChoices.map(rc => rc.id)
        }
      }]);
      const stringsMap = {};
      if (Array.isArray(strings['rewardChoice.name'])) {
        strings['rewardChoice.name'].forEach(s => {
          stringsMap[s.stringAttributes.rewardChoiceId] = s;
        });
      }
      let rewardChoiceOptions = [];
      rewardChoices.forEach(rc => {
        if (stringsMap[rc.id]) {
          rewardChoiceOptions.push({
            id: rc.id,
            name: stringsMap[rc.id].value
          });
        }
      });
      rewardChoiceOptions = rewardChoiceOptions.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
      this.setState({
        rewardChoices: rewardChoiceOptions,
        loading: false
      });
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false
      });
    }
  };
}
exports.default = RewardChoiceLabel;
//# sourceMappingURL=reward-choice-label.js.map